import { render, staticRenderFns } from "./PedigreeChart.vue?vue&type=template&id=ce54b266&"
import script from "./PedigreeChart.vue?vue&type=script&lang=js&"
export * from "./PedigreeChart.vue?vue&type=script&lang=js&"
import style0 from "./PedigreeChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports